import { render, staticRenderFns } from "./InviteListSettings.vue?vue&type=template&id=47373c94"
import script from "./InviteListSettings.vue?vue&type=script&lang=js"
export * from "./InviteListSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports